import { Stack } from '@appcues/sonar';
import styled from 'styled-components';

export const Container = styled(Stack)`
  text-align: center;
  height: 100%;
  max-width: 480px;
  margin: auto;
`;

export const SadEmoji = styled.p`
  font-size: 48px;
`;

export const HorizontalRule = styled.hr`
  border: none;
  background-color: var(--color-neutral-200);
  height: 1px;
  margin: 1rem 0;
  width: 240px;
`;
